import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthdataService } from '../authdata.service';





@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {







  LoginError:any;
  loginForm:any;

  constructor(private _AuthdataService:AuthdataService,private _Router:Router) {


    this.loginForm= new FormGroup({

      'email': new FormControl('',[Validators.email, Validators.required]),
      'password':new FormControl('',[Validators.required, Validators.minLength(8)]),


    })






   }



    
getLoginData(FormData:FormGroup){

  this._AuthdataService.getSignIn(FormData.value).subscribe((data)=>{

    
    if(data.message == "success"){
      this._AuthdataService.UserInfo ( data.user.first_name,  data.user.last_name, data.user.email, data.token,  )
      
     
      localStorage.setItem('Token', data.token)

      this._Router.navigate([`/home`])

    }else { 
      this.LoginError= data.message
    }

  })
}



  ngOnInit(): void {
  }

}
